import { DigitalObject } from '../../rendering/binary/DigitalObject.js';

/**
 * Procedural building volume rendered with binary glyph surfaces.
 */
export class Building {
  /**
   * @param {{
   *   material: import('../../rendering/binary/BinaryMaterial.js').BinaryMaterial;
   *   centerX: number;
   *   centerZ: number;
   *   width: number;
   *   depth: number;
   *   height: number;
   *   cellsPerMeter: number;
   *   seed: number;
   *   cellIdBase: number;
   *   shape?: 'building' | 'facade' | 'box' | 'pillar';
   *   name?: string;
   * }} options
   */
  constructor({
    material,
    centerX,
    centerZ,
    width,
    depth,
    height,
    cellsPerMeter,
    seed,
    cellIdBase,
    shape = 'building',
    name = 'Building',
  }) {
    this.width = width;
    this.depth = depth;
    this.height = height;
    this.centerX = centerX;
    this.centerZ = centerZ;

    this.digital = new DigitalObject({
      material,
      shape,
      size: [width, height, depth],
      position: [centerX, height / 2, centerZ],
      cellsPerMeter,
      seed,
      cellIdBase,
      name,
    });

    this.cellsUsed = this.digital.cellsUsed;
    this.maxColumns = this.digital.surfaces.reduce(
      (max, s) => Math.max(max, s.columns),
      1,
    );
  }

  get group() {
    return this.digital.group;
  }

  getCollider() {
    return this.digital.getCollider();
  }

  dispose() {
    this.digital.dispose();
  }
}
